

export const CONTACTUSREQUEST = "CONTACTUSREQUEST";
export const CONTACTUSSUCCESS = "CONTACTUSSUCCESS";
export const CONTACTUSFAILURE = "CONTACTUSFAILURE";